import { render, staticRenderFns } from "./mobile-captcha-renderer.vue?vue&type=template&id=5a99fd00&"
import script from "./mobile-captcha-renderer.vue?vue&type=script&lang=js&"
export * from "./mobile-captcha-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports